import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "row h-100" };
const _hoisted_2 = { class: "col-2 border-end" };
const _hoisted_3 = { class: "sticky-top-20 g-catpane__body" };
const _hoisted_4 = { class: "col-10" };
const _hoisted_5 = { key: 0 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_treeview = _resolveComponent("g-treeview");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_g_treeview, {
                    class: "mb-4",
                    "data-source": _ctx.nodes,
                    "key-member": "nodeID",
                    "data-structure": "tree"
                }, null, 8, ["data-source"])
            ])
        ]),
        _createElementVNode("div", _hoisted_4, [
            (_ctx.$route.params.pathMatch)
                ? (_openBlock(), _createElementBlock("pre", _hoisted_5, _toDisplayString(_ctx.$route.params.pathMatch.join('/')), 1))
                : _createCommentVNode("", true)
        ])
    ]));
}
